import { render, staticRenderFns } from "./SimulateReport.vue?vue&type=template&id=56020a31&scoped=true"
import script from "./SimulateReport.vue?vue&type=script&lang=js"
export * from "./SimulateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56020a31",
  null
  
)

export default component.exports